import { useEffect, useState } from 'react';
import { Box, Grid, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import SliderBlock from './SliderBlock';

import { ID_SITE } from '@shared/conf/env';
import { getSliders, getStaticSlider } from '@shared/services/services';

let cacheSliders = null;
let cacheStatic = null;

const params = { sites: ID_SITE, page: 1, per_page: 30 };

const ImageSlider = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // <600px

  const [sliders, setSliders] = useState([]);
  const [staticImg, setStaticImg] = useState(null);

  useEffect(() => {
    const load = async () => {
      if (!cacheSliders) {
        const res = await getSliders(params);
        cacheSliders = res.data;
      }
      if (!cacheStatic) {
        const s = await getStaticSlider();
        cacheStatic = s;
      }

      setSliders(cacheSliders);
      setStaticImg(cacheStatic);
    };
    load();
  }, []);

  // MOBILE → un solo slider con todo
  if (isMobile) {
    const merged = staticImg ? [staticImg, ...sliders] : sliders;
    return (
      <Box
        id="box-slider-mobile"
        sx={{
          width: '100%',
          px: 0,
          mt: 2,
          mb: 2,
          boxSizing: 'border-box',
        }}
      >
        <SliderBlock items={merged} />
      </Box>
    );
  }

  // DESKTOP → dos sliders lado a lado
  return (
    <Grid
      container
      columnSpacing={4}
      style={{ marginBottom: '20px', marginTop: '20px' }}
    >
      <Grid item xs={6}>
        <SliderBlock items={sliders} />
      </Grid>
      <Grid item xs={6}>
        <SliderBlock
          items={staticImg ? [staticImg] : []}
          autoplay={false}
          showArrows={false}
        />
      </Grid>
    </Grid>
  );
};

export default ImageSlider;
